<template>
  <image-video-block
    :alt="alt"
    :video-url="videoUrl"
    :caption="caption"
  />
</template>

<script>
import ImageVideoBlock from '@/vue/blocks/ImageVideoBlock/imageVideoBlock'

export default {
  name: "VideoBlock",
  components: {
    ImageVideoBlock
  },
  props: {
    alt: {
      type: String,
      default: 'Film från youtube, saknar beskrivning'
    },
    caption: {
      type: String,
      default: ""
    },
    videoUrl: {
      type: String,
      default: ""
    }
  }
}
</script>
